// extracted by mini-css-extract-plugin
export default {"busca":"Busca_busca__rmHnR","input":"Busca_input__rB5yM"};